import apiClient from '../apiClient';
import { UPLOAD_PREVIEW_ACCOMODATION_ITEM_URL } from '../apiUrl';

const uploadMasterDataPreviewAccomodationItemApi = data => {
  return apiClient.post(UPLOAD_PREVIEW_ACCOMODATION_ITEM_URL, data);
};

export default uploadMasterDataPreviewAccomodationItemApi;
